<template>
   <input class="datetimepicker" :placeholder="placeholder" :value="modelValue" type="text" :disabled="disabled"/>
</template>

<script>
    import $ from 'jquery';
    import 'jquery-datetimepicker/build/jquery.datetimepicker.full'

    export default {
        name: 'date-time-picker',
        props: {
            placeholder: {
                type: String
            },
            modelValue: {
                type: String,
                required: true,
                //default: '00:00'
            },
            options: {
                type: Object,
                default: () => {
                    return {
                        datepicker: true,
                        timepicker: true,
                        format: 'H:i',
                        minDate: false
                    }
                }
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                dateTimePicker: null,
            };
        },
        mounted() {
            this.dateTimePicker = $(this.$el)
                .datetimepicker(
                    {
                       value: this.value,
                       datepicker: this.options.datepicker,
                       timepicker: this.options.timepicker,
                       format: this.options.format,
                       minDate: this.options.minDate,
                       onChangeDateTime: ( dp, $input) => {
                           this.$emit('update');
                           this.$emit('update:modelValue', $input.val())
                    }
                });
        },
        methods: {

        }

    };
</script>

